// Dummy data for the website
import {
  FaCalculator, FaBalanceScale, FaGraduationCap, FaChartLine, FaFileAlt,
  FaClipboardCheck, FaFileContract, FaUsers, FaBook,
  FaCertificate, FaAward, FaBuilding, FaShieldAlt, FaFileInvoiceDollar,
  FaRegChartBar, FaUserShield, FaLaptopCode, FaCheckCircle, FaMoneyCheckAlt,
  FaFileSignature, FaIndustry, FaBriefcase, FaUniversity, FaPercentage
} from 'react-icons/fa';
import { HiOfficeBuilding } from 'react-icons/hi';
import { MdAccountBalance, MdAssignment, MdReceipt } from 'react-icons/md';

export const companyInfo = {
  name: "Acharya Associates",
  tagline: "Your Trusted Partner in Legal, Tax & Training",
  description: "Providing comprehensive solutions in Legal Services, Tax Consultation and Training Academy since 2006.",
  description2: "At Acharya Associates, our mission is to provide expert legal and tax consultancy services with integrity, precision, and a client-centric approach. We are committed to guiding businesses, organizations, and individuals through complex legal frameworks, ensuring compliance, risk mitigation, and strategic legal solutions.",
  contact: {
    phone: "+91 90332 52876",
    phone2: "+91 99094 51202",
    email: "mehul365@gmail.com",
    email2: "acharya_phm@yahoo.com",
    address: "TF - 302, 303, 304, Siddharth Magnum Plus, Besides Bansal Mall, Tarsali-Danteshwar Ring Road, Vadodara - 390009",
  }
};

export const services = [
  {
    id: 1,
    title: "Legal Services",
    icon: FaBalanceScale,
    description: "Comprehensive legal solutions for corporate and individual clients. Professional representation across all legal matters with dedicated expertise.",
    features: [
      { text: "PF, ESIC, Shops & Establishment, PT Registration", icon: FaBuilding },
      { text: "UDYAM / MSME / ISO Registration", icon: HiOfficeBuilding },
      { text: "Legal Compliances under Factories Act, Contract Labour Act, Bonus & Gratuity Act", icon: FaUserShield },
      { text: "Startup Recognition & Tax Exemption under DPIIT", icon: FaFileContract },
      { text: "Record Keeping & Periodical Audit", icon: FaFileContract }
    ],
    color: "tan",
    url: "/services/legal"
  },
  {
    id: 2,
    title: "Tax Consultation",
    icon: FaCalculator,
    description: "Expert tax planning and compliance services for individuals and businesses. We help you navigate complex tax regulations with precision and care.",
    features: [
      { text: "Income Tax, GST, PAN", icon: FaChartLine },
      { text: "Book Keeping & Accounting", icon: FaFileAlt },
      { text: "Finalization of Accounts & Tax Audit", icon: FaFileInvoiceDollar },
      { text: "Project Reports, CMA Data & Loan Approval", icon: FaClipboardCheck },
      { text: "Investment & Tax Planner", icon: FaClipboardCheck }
    ],
    color: "gold",
    url: "/services/tax"
  },
  {
    id: 3,
    title: "Training Academy",
    icon: FaGraduationCap,
    description: "Industry-leading training programs for aspiring legal professionals. Learn from experienced practitioners with real-world insights.",
    features: [
      { text: "Two months Duration", icon: FaRegChartBar },
      { text: "Legal Compliances Training", icon: FaBook },
      { text: "Placement Assistance", icon: FaBriefcase },
      { text: "Training from Seasoned Experts", icon: FaUserShield },
      { text: "ISO Registered Certification", icon: FaCertificate }
    ],
    color: "beige",
    url: "/services/academy"
  },
];

// Detailed services list for Services page
export const detailedServices = [
  {
    id: 1,
    category: "Registration & Compliance",
    icon: FaBuilding,
    items: [
      { name: "PF, ESIC Registration", icon: FaShieldAlt },
      { name: "Shops & Establishment Registration", icon: HiOfficeBuilding },
      { name: "PT Registration", icon: FaFileAlt },
      { name: "UDYAM / MSME Registration", icon: FaIndustry },
      { name: "ISO Registration", icon: FaCertificate },
      { name: "Digital Signature", icon: FaFileSignature },
    ]
  },
  {
    id: 2,
    category: "Legal Compliances",
    icon: FaBalanceScale,
    items: [
      { name: "Factories Act Compliance", icon: FaIndustry },
      { name: "Contract Labour Act Compliance", icon: FaUsers },
      { name: "Bonus & Gratuity Act Compliance", icon: FaMoneyCheckAlt },
      { name: "Legal Compliances Training & Placement", icon: FaGraduationCap },
    ]
  },
  {
    id: 3,
    category: "Accounting & Taxation",
    icon: FaCalculator,
    items: [
      { name: "Income Tax Filing & Planning", icon: FaFileInvoiceDollar },
      { name: "GST Services", icon: FaPercentage },
      { name: "PAN Card Services", icon: MdReceipt },
      { name: "Book Keeping & Accounting", icon: FaBook },
      { name: "Finalization of Accounts", icon: FaCheckCircle },
      { name: "Tax Audit", icon: FaClipboardCheck },
    ]
  },
  {
    id: 4,
    category: "Record Keeping & Audit",
    icon: FaFileAlt,
    items: [
      { name: "Record Keeping & Periodical Audit", icon: MdAssignment },
      { name: "Project Reports", icon: FaRegChartBar },
      { name: "CMA Data Preparation", icon: FaChartLine },
    ]
  },
  {
    id: 5,
    category: "Financial Services",
    icon: MdAccountBalance,
    items: [
      { name: "Loan Approval Assistance", icon: FaUniversity },
      { name: "Investment Planning", icon: FaChartLine },
      { name: "Tax Planner Services", icon: FaCalculator },
    ]
  },
  {
    id: 6,
    category: "Startup & Recognition",
    icon: FaAward,
    items: [
      { name: "Startup Recognition under DPIIT", icon: FaLaptopCode },
      { name: "Tax Exemption for Startups", icon: FaPercentage },
    ]
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    role: "CEO, TechCorp Solutions",
    image: `https://ui-avatars.com/api/?name=${encodeURIComponent("Rajesh Sharma")}&background=cca361&color=fff&size=128`,
    text: "Acharya Associates has been instrumental in managing our corporate tax matters. Their expertise and professionalism are unmatched.",
    rating: 5,
    service: "Tax Consultation"
  },
  {
    id: 2,
    name: "Priya Mehta",
    role: "Real Estate Developer",
    image: `https://ui-avatars.com/api/?name=${encodeURIComponent("Priya Mehta")}&background=cca361&color=fff&size=128`,
    text: "The legal team provided exceptional support during our property acquisitions. Highly recommend their services!",
    rating: 5,
    service: "Legal Services"
  },
  {
    id: 3,
    name: "Amit Kumar",
    role: "CA Student",
    image: `https://ui-avatars.com/api/?name=${encodeURIComponent("Amit Kumar")}&background=cca361&color=fff&size=128`,
    text: "The training academy's program was comprehensive and practical. The faculty's real-world experience made all the difference.",
    rating: 5,
    service: "Training Academy"
  },
];

export const stats = [
  {
    id: 1,
    number: "150+",
    label: "Happy Clients",
  },
  {
    id: 2,
    number: "45+",
    label: "Years Experience",
  },
  {
    id: 3,
    number: "175+",
    label: "Students Trained",
  }
];

// Note: `startYear` is the year the member began their career/association with
// the firm. Years of experience are computed dynamically from it (see Team.js).
export const teamMembers = [
  {
    id: 1,
    name: "Mr. D. S. Acharya",
    role: "Founder: Senior Advocate & Legal Consultant",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319165/Dilip_u5slpd.png",
    startYear: 1976,
  },
  {
    id: 2,
    name: "Mr. M. D. Acharya",
    role: "Descendant: Legal Advisor & Tax Consultant",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319164/Mehul_iurwhf.png",
    startYear: 2010,
  },
  {
    id: 3,
    name: "Ms. Meena Acharya",
    role: "Co-Proprietor: Legal Advisor & Labour Laws Consultant",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319164/Meena_n2ery7.png",
    startYear: 2021,
  },
  {
    id: 4,
    name: "Vikrant Patel",
    role: "Sr. Compliance Executive",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319172/Vikrant_y5lerl.png",
    startYear: 2009,
  },
  {
    id: 5,
    name: "Purnima Gaekwad",
    role: "Sr. Compliance Executive",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319163/Purnima_pe19za.png",
    startYear: 2009,
  },
  {
    id: 6,
    name: "Divya Patel",
    role: "Sr. HR Assistant",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319162/Divya_iyn0de.png",
    startYear: 2011,
  },
  {
    id: 7,
    name: "Anjali Khachane",
    role: "HR Administrator",
    image: "https://res.cloudinary.com/durpdzokm/image/upload/v1778319162/Anjali_uinnv8.png",
    startYear: 2023,
  },
  {
    id: 8,
    name: "Hetal Raval",
    role: "Payroll & HR Administrator",
    image: "",
    startYear: 2024,
  },
];

export const galleryImages = [
  { id: 1, url: "/gallery/image1.jpg", caption: "Our founding members" },
  { id: 2, url: "/gallery/image2.jpg", caption: "Consultation point" },
  { id: 3, url: "/gallery/image3.jpg", caption: "Office Outdoors" },
  { id: 4, url: "/gallery/image4.jpg", caption: "Our faith in god" },
  { id: 5, url: "/gallery/image5.jpg", caption: "Office interior" },
  { id: 6, url: "/logo.png", caption: "Logo" },
];

export const clients = [
  {
    id: 1,
    name: "AERZEN MACHINERY INDIA",
    logo: "/logos/Aerzen.png"
  },
  {
    id: 2,
    name: "ALUPLAST INDIA",
    logo: "/logos/Aluplast.svg"
  },
  {
    id: 3,
    name: "GEA PROCESS ENGG",
    logo: "/logos/Gea.svg"
  },
  {
    id: 4,
    name: "KERAKOLL INDIA",
    logo: "/logos/kerakoll.png"
  },
  {
    id: 5,
    name: "AXALTA COATING SYSTEMS INDIA",
    logo: "/logos/axalta.png"
  },
  {
    id: 6,
    name: "BRENTWOOD INDUSTRIES INDIA",
    logo: "/logos/brentwood.svg"
  },
  {
    id: 7,
    name: "FINOLEX INDUSTRIES",
    logo: "/logos/finolex.png"
  },
  {
    id: 8,
    name: "XYLEM WATER SOLUTIONS",
    logo: "/logos/xylem.png"
  },
  {
    id: 9,
    name: "PROFINE INDIA",
    logo: "/logos/profine.png"
  },
  {
    id: 10,
    name: "FMC INDIA",
    logo: "/logos/fmc.png"
  },
  {
    id: 11,
    name: "EXXAT SYSTEMS",
    logo: "/logos/exxat.png"
  },
  {
    id: 12,
    name: "CIVICA",
    logo: "/logos/civica.svg"
  },
  {
    id: 13,
    name: "STELLAR FORMULATIONS",
    logo: "/logos/stellar.png"
  },
  {
    id: 14,
    name: "SYENSQO SPECIALITIES INDIA",
    logo: "/logos/syensqo.png"
  },
  {
    id: 15,
    name: "VIROC HOSPITAL",
    logo: "/logos/viroc.webp"
  },
  {
    id: 16,
    name: "WINDAR RENEWABLE ENERGY",
    logo: "/logos/windar.png"
  }
];
